import { THistoryTimeRange } from "./carrier-capabilities.interfaces";
import { TCategory, TSubcategory } from "./interfaces.v3";
  export enum Severity  {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
  }
  
  export enum ActionCode {
    OUTSOURCE_ELIGIBILITY = 'OUTSOURCE_ELIGIBILITY',
    OUTSOURCE_BREAKDOWN = 'OUTSOURCE_BREAKDOWN',
    CHECK_CARRIER_PORTAL = 'CHECK_CARRIER_PORTAL',
    EXTRACT_PORTAL_DATA_WITH_API = 'EXTRACT_PORTAL_DATA_WITH_API',
    CONTACT_CARRIER = 'CONTACT_CARRIER'
  }

  export enum ReasonCode {
    // CLEARINGHOUSE_MISSING
    CLEARINGHOUSE_MISSING_PLAN_STATUS = 'CLEARINGHOUSE_MISSING_PLAN_STATUS',
    CLEARINGHOUSE_MISSING_INSURANCE_REMAINING = 'CLEARINGHOUSE_MISSING_INSURANCE_REMAINING',
    CLEARINGHOUSE_MISSING_HISTORY = 'CLEARINGHOUSE_MISSING_HISTORY',
    CLEARINGHOUSE_MISSING_EFFECTIVE_DATE = 'CLEARINGHOUSE_MISSING_EFFECTIVE_DATE',
    CLEARINGHOUSE_MISSING_DEDUCTIBLE_REMAINING = 'CLEARINGHOUSE_MISSING_DEDUCTIBLE_REMAINING',

    // VERISMART MISSING
    VERISMART_MISSING_PLAN_STATUS = 'VERISMART_MISSING_PLAN_STATUS',
    VERISMART_MISSING_INSURANCE_REMAINING = 'VERISMART_MISSING_INSURANCE_REMAINING',

    // ZERO
    ZERO_INSURANCE_REMAINING = 'ZERO_INSURANCE_REMAINING',

    // PARTIALLY_PROVIDED
    PARTIALLY_PROVIDED_CLEARINGHOUSE_HISTORY = 'PARTIALLY_PROVIDED_CLEARINGHOUSE_HISTORY',
    PARTIALLY_PROVIDED_PORTAL_HISTORY = 'PARTIALLY_PROVIDED_PORTAL_HISTORY',
    
    // PORTAL_MISSING
    PORTAL_MISSING_PLAN_STATUS = 'PORTAL_MISSING_PLAN_STATUS',
    PORTAL_MISSING_INSURANCE_REMAINING = 'PORTAL_MISSING_INSURANCE_REMAINING',
    PORTAL_MISSING_HISTORY = 'PORTAL_MISSING_HISTORY',
    
    // PORTAL_PROVIDED
    PORTAL_PROVIDED_PLAN_STATUS = 'PORTAL_PROVIDED_PLAN_STATUS',
    PORTAL_PROVIDED_INSURANCE_REMAINING = 'PORTAL_PROVIDED_INSURANCE_REMAINING',
    PORTAL_PROVIDED_HISTORY = 'PORTAL_PROVIDED_HISTORY',

    // PORTAL API_PROVIDED
    PORTAL_API_PROVIDED_PLAN_STATUS = 'PORTAL_API_PROVIDED_PLAN_STATUS',
    PORTAL_API_PROVIDED_INSURANCE_REMAINING = 'PORTAL_API_PROVIDED_INSURANCE_REMAINING',
    PORTAL_API_PROVIDED_HISTORY = 'PORTAL_API_PROVIDED_HISTORY',

    // PLAN
    PLAN_MISSING_FIELDS_LIMIT = 'PLAN_MISSING_FIELDS_LIMIT',
    PLAN_MISSING_FIELDS = 'PLAN_MISSING_FIELDS',

    // OTHER
    OTHER_VERIFICATION_OUTSOURCED = "OTHER_VERIFICATION_OUTSOURCED",
    OTHER_NEW_PATIENT = 'OTHER_NEW_PATIENT',
    OTHER_LONG_ABSENT_PATIENT = 'OTHER_LONG_ABSENT_PATIENT'
  }
  
  export enum Category {
    ELIGIBILITY = 'ELIGIBILITY',
    BREAKDOWN = 'BREAKDOWN'
  }
  export interface IRecommendationHistoryCarrierMetadata {
    timeRange?: THistoryTimeRange;
    notProvidedCategories: TCategory[];
    notProvidedSubcategories: TSubcategory[];
}
export interface IRecommendationHistoryMetadata {
    portal?: IRecommendationHistoryCarrierMetadata;
    clearinghouse?: IRecommendationHistoryCarrierMetadata;
}

export interface IRecommendationMetadata {
    history?: IRecommendationHistoryMetadata;
    planDataIssuesCount: number;
    patientDataIssuesCount: number;
    patientDataIssuesMandatoryCount: number;
    patientDataIssuesOptionalCount: number;
}

export interface ICompoundRecommendation {
  reasonMessages: string[];
  recommendationMessages: string[];
  generalReasonMessage: string;
}
  
  export interface Recommendation {
    actions: ActionCode[];
    reasonCodes: ReasonCode[];
    compoundRecommendation: ICompoundRecommendation;
    severity: Severity;
    category: Category;
    metadata: IRecommendationMetadata;
  }